import confetti from "canvas-confetti";

export const fireConfetti = () => {
  confetti({
    angle: 60,
    particleCount: 50,
    spread: 80,
    origin: { y: 0.9, x: 0 }
  });
  confetti({
    angle: 120,
    particleCount: 50,
    spread: 80,
    origin: { y: 0.9, x: 1 }
  });
};
